import { render, staticRenderFns } from "./SettlementPage.vue?vue&type=template&id=a77124aa&scoped=true&lang=html&"
import script from "./SettlementPage.vue?vue&type=script&lang=js&"
export * from "./SettlementPage.vue?vue&type=script&lang=js&"
import style0 from "./SettlementPage.vue?vue&type=style&index=0&id=a77124aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77124aa",
  null
  
)

export default component.exports